/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { APIResponseError } from './APIResponseError';
import {
    APIResponseErrorFromJSON,
    APIResponseErrorFromJSONTyped,
    APIResponseErrorToJSON,
    APIResponseErrorToJSONTyped,
} from './APIResponseError';
import type { APIMeta } from './APIMeta';
import {
    APIMetaFromJSON,
    APIMetaFromJSONTyped,
    APIMetaToJSON,
    APIMetaToJSONTyped,
} from './APIMeta';
import type { StatsGetResponse } from './StatsGetResponse';
import {
    StatsGetResponseFromJSON,
    StatsGetResponseFromJSONTyped,
    StatsGetResponseToJSON,
    StatsGetResponseToJSONTyped,
} from './StatsGetResponse';

/**
 * 
 * @export
 * @interface GetStats200Response
 */
export interface GetStats200Response {
    /**
     * 
     * @type {APIMeta}
     * @memberof GetStats200Response
     */
    meta?: APIMeta;
    /**
     * 
     * @type {Array<APIResponseError>}
     * @memberof GetStats200Response
     */
    errors?: Array<APIResponseError>;
    /**
     * 
     * @type {StatsGetResponse}
     * @memberof GetStats200Response
     */
    result: StatsGetResponse;
}

/**
 * Check if a given object implements the GetStats200Response interface.
 */
export function instanceOfGetStats200Response(value: object): value is GetStats200Response {
    if (!('result' in value) || value['result'] === undefined) return false;
    return true;
}

export function GetStats200ResponseFromJSON(json: any): GetStats200Response {
    return GetStats200ResponseFromJSONTyped(json, false);
}

export function GetStats200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetStats200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'meta': json['meta'] == null ? undefined : APIMetaFromJSON(json['meta']),
        'errors': json['errors'] == null ? undefined : ((json['errors'] as Array<any>).map(APIResponseErrorFromJSON)),
        'result': StatsGetResponseFromJSON(json['result']),
    };
}

export function GetStats200ResponseToJSON(json: any): GetStats200Response {
    return GetStats200ResponseToJSONTyped(json, false);
}

export function GetStats200ResponseToJSONTyped(value?: GetStats200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'meta': APIMetaToJSON(value['meta']),
        'errors': value['errors'] == null ? undefined : ((value['errors'] as Array<any>).map(APIResponseErrorToJSON)),
        'result': StatsGetResponseToJSON(value['result']),
    };
}

